<template>
  <img :src="require('@/assets/images/' + source)" :style="style" />
</template>

<script>
export default {
  name: "DefaultPackageImage",
  props: {
    height: {
      type: Number,
      default: 200,
    },
    width: {
      type: Number,
      default: 100,
    },
    kind: {
      type: String,
      default: "solution",
    },
  },
  data: function () {
    return {
      // imagePath:"/images/"
    };
  },
  methods: {},
  computed: {
    style: function () {
      return `height: ${this.height}px; max-width:${this.width}px;margin: 0 auto`;
    },
    source: function () {
      let file = "bottle_icon.svg";
      if (this.kind.toLowerCase().includes("gel")) file = "gel_icon.svg";
      if (this.kind.toLowerCase().includes("ointment"))
        file = "ointment_icon.svg";
      if (this.kind.toLowerCase().includes("injection"))
        file = "injection_icon.svg";
      if (this.kind.toLowerCase().includes("oral"))
        file = "oral_bottle_icon.svg";
      return file;
    },
  },
};
</script>

<style scoped></style>
